<template>
  <div class="navbar-box">
    <div class="navbar">
      <div class="logo" @click="toHome">
        <img src="@/assets/mobile/logo_global.jpg" alt="" />
      </div>
      <div @click="showMenu" class="menu">
        <img src="@/assets/mobile/clou.jpg" alt="" />
      </div>
    </div>
    <div class="cover" v-if="!showSubMenu"></div>
    <navbar-menu id="isFixed" v-show="!showSubMenu" ref="menu" @handle="setActionHandle"></navbar-menu>
  </div>
</template>

<script>
import '@/compiled-icons/rocket';
import '@/compiled-icons/phone';
import '@/compiled-icons/clock';
import '@/compiled-icons/email';
import NavbarMenu from '@/mobile/components/navbar-menu.vue';
import $ from 'jquery';

export default {
  name: 'index',
  components: {
    // CommonDialog: () => import('../pc/dialog/index.vue'),
    NavbarMenu
  },
  data() {
    return {
      showSubMenu: false,
      Visible: false,
      activeIndex: '/home',
      showList: false,
      goodsList: [
        { img: 'occasion.jpg', tag: '流水线', text1: 'ACE Line', text2: '血液样本前处理' },
        { img: 'occasion.jpg', tag: '工作站', text1: 'Lib Master', text2: '测序文库构建' },
        { img: 'occasion.jpg', tag: '流水线', text1: 'Lib Flow', text2: '测序文库全流程构建' },
        { img: 'occasion.jpg', tag: '工作站', text1: 'QC Master', text2: '微生物培养观察' },
        { img: 'occasion.jpg', tag: '工作站', text1: 'Gemini', text2: '生信分析一体机' },
        { img: 'occasion.jpg', tag: '工作站', text1: 'Lab Net', text2: '可组合编程物料移送' }
      ]
    };
  },
  methods: {
    setActionHandle() {
      this.showSubMenu = true;
    },
    showMenu() {
      console.log('1111111');
      this.$refs.menu.changeIndex(window.location.pathname);
      this.showSubMenu = !this.showSubMenu;
      $('#isFixed').toggle();
    },
    dialogClick() {
      this.Visible = true;
    },
    show() {
      this.showList = true;
    },
    hide() {
      this.showList = false;
    },
    handleSelect(key) {
      this.activeIndex = key;
    },
    toHome() {
      this.$router.push('/home');
      this.activeIndex = '/home';
    },
    toList(item) {
      console.log(item);
      this.$router.push({ path: '/bioengineering-technology', query: { name: item.text1 } });
      this.activeIndex = '/bioengineering-technology';
    },
    remove() {
      window.addEventListener('click', () => {
        // 这里写收起下拉框的逻辑代码
        $('#isFixed').toggle();
      });
    }
  },
  mounted() {
    this.showSubMenu = true;
    this.activeIndex = window.location.pathname;
  },
  beforeMount() {
    $('#isFixed').toggle();
  }
  //
};
</script>

<style lang="less" scoped>
.navbar-box {
  z-index: 99;
  position: relative;
  display: flex;
  height: 120px;
  align-items: center;

  .navbar {
    width: 100%;
    height: 120px;
    position: fixed;
    display: flex;
    align-items: center;
    background: #ffffff;
    z-index: 1000;
    justify-content: space-between;
    border-bottom: 1px solid rgba(91, 104, 129, 0.2);

    .logo {
      margin-left: 32px;
      cursor: pointer;
      display: flex;
      align-items: center;
      height: 50px;
      width: 140px;

      img {
        height: 50px;
        width: 140px;
      }
    }

    .menu {
      display: flex;
      height: 100%;
      z-index: 2000;
      align-items: center;
      margin-right: 38px;
      img {
        // background: #377cff;
        height: 48px;
        width: 48px;
      }
    }
  }
  .cover {
    border-radius: 8px;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: #081630;
    opacity: 0.8;
  }
}
</style>



// WEBPACK FOOTER //
// src/mobile/components/navbar.vue